import { router } from 'expo-router';
import { useContext, useEffect } from 'react';

import { AuthContext } from 'state/auth';
import { routes } from 'utils/routing';

export default function useUnauthRedirects() {
  const { loading, isAuthenticated, originLocation } = useContext(AuthContext);

  useEffect(() => {
    if (loading) {
      return;
    }

    if (isAuthenticated) {
      if (originLocation === '/cart') {
        router.dismissTo(routes.cart);
        return;
      }
      if (originLocation === 'PYPESTREAM' || originLocation === routes.support) {
        router.dismissTo(routes.support);
        return;
      }
      router.replace(routes.base);
    }
  }, [isAuthenticated, loading, originLocation]);
}
